import { Link } from 'react-router';

import { useLanguage } from '@/contexts/language-context';
import { useEntitlements } from '@/hooks/use-entitlements';
import { useRole } from '@/hooks/use-role';
import { fillTemplate, formatRelativeDays } from '@/lib/utils';

/**
 * Shown only while the active business is on an unconverted trial. Reuses
 * useEntitlements' cached getBusiness query — no extra network call.
 */
export function TrialBanner() {
  const { t } = useLanguage();
  const { isOwner } = useRole();
  const { isPending, subscriptionStatus, trialEndsAt } = useEntitlements();

  if (!isOwner || isPending || subscriptionStatus !== 'trialing' || !trialEndsAt) {
    return null;
  }

  return (
    <div
      className="flex items-center justify-between gap-3 border-b bg-blue-50 px-4 py-2 text-sm text-blue-800 dark:bg-blue-900/20 dark:text-blue-300"
      data-testid="trial-banner"
    >
      <span>{fillTemplate(t.billingTrialBannerText, { when: formatRelativeDays(trialEndsAt) })}</span>
      <Link to="/billing" className="font-medium underline underline-offset-2 shrink-0">
        {t.billingSubscribe}
      </Link>
    </div>
  );
}
